<script>
export default {
  props: {
    isPrimeiroPasso: {
      type: Boolean,
      default: false
    },
    isUltimoPasso: {
      type: Boolean,
      default: false
    },
    showButtonSalvar: {
      type: Boolean,
      default: false
    },
    isEtapaSalva: {
      type: Boolean,
      default: true
    },
    showButtonCancelar: {
      type: Boolean,
      required: false,
      default: true
    },
    showButtonDownload: {
      type: Boolean,
      required: false,
      default: false
    },
    finalizarLabel: {
      type: String,
      required: false,
      default: 'Finalizar'
    },
    isIntroPasso: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    salvar () {
      this.$emit('salvar')
    },

    voltarAba () {
      this.$emit('voltar')
    },

    cancelar () {
      this.$emit('cancelar')
    },

    proximo () {
      this.$emit('proximo')
    },

    finalizar () {
      this.$emit('finalizar')
    },

    download () {
      this.$emit('download')
    }
  }

}
</script>

<template>
  <div class="buttons">
    <div class="btn marginBotton">
      <el-button
        type="default"
        @click="voltarAba"
        name="voltar"
        v-show="!isPrimeiroPasso"
      >
        <span class="center">
          <i class="fas fa-chevron-left"></i>
          <span>&nbsp; Voltar</span>
        </span>
      </el-button>

      <el-button
        @click="cancelar"
        name="cancelar"
        class="cancelarButton"
        v-show="showButtonCancelar && !isIntroPasso"
      >
        <span class="center">
          <i class="fas fa-times"></i>
          <span>&nbsp; Cancelar</span>
        </span>
      </el-button>
    </div>

    <div class="btn">
      <el-button
        class="buttonMargin"
        type="success"
        @click="salvar"
        name="salvar"
        v-show="showButtonSalvar"
      >
        <span class="center">
          <i class="fas fa-save"></i>
          <span>&nbsp; Salvar</span>
        </span>
      </el-button>

      <el-button
        type="default"
        @click="download"
        name="download"
        v-show="showButtonDownload"
      >
        <span class="center">
          <span>Download PDF&nbsp;</span>
          <i class="fa fa-download"></i>
        </span>
      </el-button>

      <el-button
        class="buttonMargin"
        type="default"
        @click="proximo"
        name="proximo"
        v-show="!isUltimoPasso"
      >
        <span class="center">
          <span>Próximo&nbsp;</span>
          <i class="fas fa-chevron-right"></i>
        </span>
      </el-button>

      <el-button
        type="primary"
        @click="finalizar"
        name="finalizar"
        v-show="isUltimoPasso"
      >
        <span class="center">
          <i class="fa fa-check"></i>
          <span>&nbsp;{{ finalizarLabel }}</span>
        </span>
      </el-button>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import './styles.scss';
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Buttons/ButtonsCadastroSicarf/ButtonsCadastroSicarf.vue